<template lang="pug">
h3(v-if="field.value", v-html="field.value")
h4(v-if="field.sub", v-html="field.sub")
</template>

<script>
export default {
  name: 'Title',
  props: {
    field: Object,
  },
};
</script>

<style lang="scss" scoped>
h3 {
  font-weight: 700;
  font-size: 1.125rem;
  margin: 0 0 1.75rem;
  line-height: 1;
  padding: 0;
}
h4 {
  font-weight: 400;
  font-size: 1rem;
  margin: 0 0 1.75rem;
  line-height: 1;
  padding: 0;
}
h3 + h4 {
  margin-top: -1.25rem;
}
</style>
